import { ColumnDef, Row } from "@tanstack/react-table";
import { buildAvatarDetailsColumn, buildActionColumn } from "@/components/Table";
import { toFormat } from "@/lib/dateHelpers";
import { Alumni } from "./types";
import { buildProgramLevelColumn } from "../../../_shared/_utils";

export const mapAlumni = (students: any): Alumni[] => {
  if (!students?.nodes) return [];

  return students.nodes.map((node: any) => ({
    ...node,
    id: node.id,
    name: node.displayName,
    preferredName: node.preferredName,
    enrollStartDate: node.educationLatestPgmProgram.startDate || "",
    enrollEndDate: node.educationLatestPgmProgram.completedAt || "",
    address: node.contactAddress?.address1 || "-",
    dateOfBirth: node.dateOfBirth,
    program: {
      level: node.educationLatestPgmProgram.level,
      version: node.educationLatestPgmProgram.curriculumVersion,
      completed: node.educationLatestPgmProgram.completed,
      programType: node.educationLatestPgmProgram.programType
    },
    patStatus: node.educationLatestPgmProgram?.completed ? "Complete" : "Incomplete",
    programLevels: node.educationPgmProgramHistory.map((level: any, index: number) => ({
      id: index.toString(),
      level: level.level,
      levelCode: level.levelCode,
      startDate: level.startDate,
      endDate: level.endDate,
      completed: level.completed,
      curriculumVersion: level.curriculumVersion,
      completionCode: level.completionCode,
      completedAt: level.completedAt
    }))
  }));
};

type BuildColumnsProps = {
  isCompactLayout: boolean;
  handleViewAlumni: (alumni: Alumni) => void;
};

export const buildColumns = ({ isCompactLayout, handleViewAlumni }: BuildColumnsProps): ColumnDef<Alumni, any>[] => {
  return [
    ...buildAvatarDetailsColumn<Alumni>({
      isCompactLayout,
      getTitle: (row) => row.name,
      getSubtitle: (row) => `PGA ID: ${row.pgaId}`,
      getPicture: (row) => row.profilePhoto,
      size: 300,
      minSize: 220
    }),
    {
      accessorKey: "email",
      header: "Email",
      enableSorting: false
    },
    {
      accessorKey: "enrollStartDate",
      header: "Enroll Start Date",
      cell: ({ row }: { row: Row<Alumni> }) => {
        const date = row.original.enrollStartDate;
        return date ? toFormat(date) : <span className="opacity-20">--</span>;
      },
      enableSorting: false
    },
    {
      accessorKey: "enrollEndDate",
      header: "Enroll End Date",
      cell: ({ row }: { row: Row<Alumni> }) => {
        const date = row.original.enrollEndDate;
        return date ? toFormat(date) : <span className="opacity-20">--</span>;
      },
      enableSorting: false
    },
    buildProgramLevelColumn<Alumni>({
      getProgram: (row) => row.program,
      header: "Program Version",
      displayMode: "version"
    }),
    buildActionColumn<Alumni>({
      getActions: () => [],
      onViewClick: (row, _event) => handleViewAlumni(row),
      viewButtonTitle: "View Alumni",
      actionId: () => "",
      setMenu: () => {}
    })
  ];
};
